import { useTranslation } from "react-i18next";

import { IzjavaOPristupacnostiPage } from "./IzjavaOPristupacnostiPage";
import logo from "./logo.svg";

export default function IzjavaOPristupacnosti() {
  const { t } = useTranslation();
  return (
    <IzjavaOPristupacnostiPage
      title={t("login.applicationName")}
      version={t("login.appVersion")}
      logo={logo}
    />
  );
}
